import React, { useState } from 'react';
import { FaStar, FaQuoteLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import '../style.css';

const PatientTestimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Rajesh Kumar",
      age: 45,
      treatment: "Cardiac Surgery",
      rating: 5,
      quote: "The cardiac care I received was exceptional. Dr. Sharma and his team saved my life with their expertise and compassionate care. The facilities are world-class.",
      date: "2 weeks ago",
      avatarColor: "#0072f5"
    },
    {
      id: 2,
      name: "Priya Sharma",
      age: 32,
      treatment: "Orthopedic Surgery",
      rating: 4,
      quote: "After my knee replacement, I was walking within days. The physiotherapy team is amazing and the post-operative care was excellent.",
      date: "1 month ago",
      avatarColor: "#00a3ff"
    },
    {
      id: 3,
      name: "Amit Patel",
      age: 56,
      treatment: "Neuro Surgery",
      rating: 5,
      quote: "The neurosurgery department handled my complex case with utmost professionalism. The technology used was state-of-the-art.",
      date: "3 weeks ago",
      avatarColor: "#4cd964"
    },
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToTestimonial = (index) => {
    setCurrentIndex(index);
  };

  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <FaStar 
        key={index} 
        className={`star-icon ${index < rating ? 'star-filled' : 'star-empty'}`}
      />
    ));
  };

  return (
    <div className="testimonials-section">
      {/* Header */}
      <div className="testimonials-header">
        <div className="header-content">
          <span className="testimonials-badge">Patient Feedback</span>
          <h2 className="testimonials-title">What Our Patients Say</h2>
          <p className="testimonials-subtitle">Real stories from patients who trusted us with their health</p>
        </div>
      </div>

      {/* Main Testimonials */}
      <div className="testimonials-container">
        <div className="testimonials-wrapper">
          
          {/* Featured Testimonial - Slimmed */}
          <div className="testimonials-main">
            <div className="testimonial-card featured">
              <div className="quote-icon">
                <FaQuoteLeft />
              </div>
              <p className="testimonial-quote">
                {testimonials[currentIndex].quote}
              </p>
              
              <div className="testimonial-author">
                <div className="author-avatar" style={{ background: testimonials[currentIndex].avatarColor }}>
                  {testimonials[currentIndex].name.charAt(0)}
                </div>
                <div className="author-info">
                  <h4 className="author-name">{testimonials[currentIndex].name}</h4>
                  <div className="author-details">
                    <span className="author-treatment">{testimonials[currentIndex].treatment}</span>
                    <span className="author-date">{testimonials[currentIndex].date}</span>
                  </div>
                </div>
                <div className="author-rating">
                  {renderStars(testimonials[currentIndex].rating)}
                </div>
              </div>
            </div>

            {/* Navigation Controls */}
            <div className="testimonial-controls">
              <button className="nav-btn prev-btn" onClick={prevTestimonial} aria-label="Previous testimonial">
                <FaChevronLeft />
              </button>
              
              <div className="testimonial-counter">
                <span className="current-index">{currentIndex + 1}</span>
                <span className="divider">/</span>
                <span className="total-count">{testimonials.length}</span>
              </div>
              
              <button className="nav-btn next-btn" onClick={nextTestimonial} aria-label="Next testimonial">
                <FaChevronRight />
              </button>
            </div>
          </div>

          {/* Sidebar Testimonials - Slimmed */}
          <div className="testimonials-sidebar">
            {testimonials.map((testimonial, index) => (
              <div 
                key={testimonial.id} 
                className={`sidebar-testimonial ${index === currentIndex ? 'active-sidebar' : ''}`}
                onClick={() => goToTestimonial(index)}
              >
                <div className="sidebar-content">
                  <div className="sidebar-header">
                    <div className="sidebar-avatar" style={{ background: testimonial.avatarColor }}>
                      {testimonial.name.charAt(0)}
                    </div>
                    <div className="sidebar-info">
                      <h5 className="sidebar-name">{testimonial.name}</h5>
                      <p className="sidebar-treatment">{testimonial.treatment}</p>
                    </div>
                  </div>
                  <div className="sidebar-footer">
                    <div className="sidebar-rating">
                      {renderStars(testimonial.rating)}
                    </div>
                    <span className="sidebar-date">{testimonial.date}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Quick Stats - Slim */}
      <div className="quick-stats">
        <div className="stat-item">
          <div className="stat-dot" style={{ background: '#0072f5' }}></div>
          <span>95% Patient Satisfaction</span>
        </div>
        <div className="stat-item">
          <div className="stat-dot" style={{ background: '#4cd964' }}></div>
          <span>10,000+ Treatments</span>
        </div>
        <div className="stat-item">
          <div className="stat-dot" style={{ background: '#ff6b6b' }}></div>
          <span>200+ Expert Doctors</span>
        </div>
      </div>
    </div>
  );
};

export default PatientTestimonials;